import React, { useEffect, useState } from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import './Layout.css';
import logo from './connaught.png';
import homeIcon from '../pages/images/home.png';

function Layout({ user, onLogout, openLoginModal, children }) {
    const navigate = useNavigate();
    const location = useLocation();
    const [menuOpen, setMenuOpen] = useState(false);
    const verified = ['Admin', 'Archivist', 'Member', 'Researcher', 'Secretary', 'Almoner'].includes(user?.role);
    const archiveAccess = verified && user?.role !== 'Almoner';
    const manager = ['Admin', 'Archivist'].includes(user?.role);
    useEffect(() => { setMenuOpen(false); }, [location.pathname]);
    const menuLinks = [
        ['/about', 'About'],
        ...(user ? [['/security', 'Account security']] : []),
        ...(verified ? [['/attendance', 'Lodge QR codes']] : []),
        ...(archiveAccess ? [['/calendar', 'Calendar'], ['/view-documents', 'View documents']] : []),
        ...(verified ? [['/instructions', 'Help & instructions'], ['/games', 'Games']] : []),
        ...(manager ? [['/upload-documents', 'Upload documents'], ['/staging-imports', 'Staging imports'], ['/admin', 'Admin']] : []),
        ...(manager ? [['/analytics', 'Analytics']] : []),
    ];

    return (
        <div className="layout">
            <a className="skip-link" href="#main-content">Skip to content</a>
            <header className="layout-header">
                <div className="layout-title-container">
                    <h1 className="layout-title">Welcome to Connaught Lodge #361 I.C.</h1>
                    <p className="layout-subtitle">
                        Connaught Lodge, under the Provincial Grand Lodge of South Africa Northern I.C, serves as the research lodge for Irish Freemasonry in South Africa.
                        This portal preserves its legacy, and supports Irish Masonic heritage research.
                    </p>
                </div>

                <div className="layout-buttons">
                    {user ? (
                        <button className="logout-button" onClick={onLogout}>
                            Logout ({user.username})
                        </button>
                    ) : (
                        <button className="login-button" onClick={openLoginModal}>
                            Login
                        </button>
                    )}

                    <button
                        className="home-button"
                        onClick={() => navigate('/')}
                        aria-label="Go to Home"
                        title="Go to Home"
                        type="button"
                    >
                        <img src={homeIcon} alt="" className="home-icon" />
                        <span className="home-button-text">Home</span>
                    </button>
                </div>
            </header>

            <nav className="site-navigation" aria-label="Main navigation" onKeyDown={event => { if (event.key === 'Escape') setMenuOpen(false); }}>
                <div className="site-navigation-links">
                    <NavLink to="/" end>Home</NavLink>
                    <NavLink to="/research">Research</NavLink>
                    {archiveAccess && <NavLink to="/resources">Resources</NavLink>}
                    {verified && <NavLink to="/surveys">Meetings</NavLink>}
                    <button type="button" aria-expanded={menuOpen} aria-controls="site-more-menu" onClick={() => setMenuOpen(!menuOpen)}>More {menuOpen ? '▴' : '▾'}</button>
                </div>
                {menuOpen && <div id="site-more-menu" className="site-more-menu">{menuLinks.map(([url, label]) => <NavLink key={url} to={url}>{label}</NavLink>)}</div>}
            </nav>
            <main id="main-content" className="layout-content">{children}</main>
        </div>
    );
}

export default Layout;